import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZBookmarks = z
  .object({
    bookmarkId: z.string(),
    dashboardId: z.string(),
    dashboardType: z.enum(['ENTERPRISE', 'SITE', 'ASSET', 'DEVICE']),
    bookmarkType: z.enum(['BOOKMARK', 'HOMESCREEN']),
    siteID: z.string(),
    siteName: z.string(),
    assetID: z.string(),
    assetName: z.string(),
    deviceID: z.string().nullable(),
    deviceName: z.string().nullable(),
    assetTypeId: z.string().nullable()
  })
  .optional()
export const ZData = z.array(ZBookmarks)

export const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZData)
})
export type GetBookmarkListResponce = z.infer<typeof ZData>
export type GetBookmarkListResponceAPIData = z.infer<typeof ZApiResponse>

export async function getBookmarkListDataService (
  subId: string,
  onSuccess: (GetBookmarkListResponce: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/bookmark?subId=${subId}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
